export default __webpack_public_path__ + "static/media/120.1bd02c21.svg";